<template>
  <div v-if="loaded" class="print-main">
    <div class="print-left" :style="{ height: `${this.$util.getViewHeight() - 162}px` }">
      <div id="print-content" class="print-content">
        <!-- title -->
        <div class="title-box">
          <h1 class="title-main">{{ $constant.company_info.company_name }}</h1>
          <div class="m-t-5">联系地址：{{ $constant.company_info.company_address }}</div>
          <div class="m-t-5">
            <span>电话：{{ $constant.company_info.company_phone }}</span>
            <span class="m-l-20">电话：0757-23305378</span>
          </div>
          <h2 class="title-sub">采购订单</h2>
        </div>

        <!-- formData1 -->
        <div class="form-main">
          <div class="form-list" v-for="(itemSt, indexSt) in formData1" :key="indexSt">
            <div class="form-item" v-for="(itemNd, indexNd) in itemSt" :key="indexNd">
              <div class="form-key">{{ itemNd.key }}{{ itemNd.key && '：' }}</div>
              <div class="form-val" v-if="itemNd.val">
                <span
                  v-if="
                    itemNd.val === 'cai_gou_bill_date' || itemNd.val === 'cai_gou_jiao_huo_ri_qi'
                  "
                >
                  {{
                    detailData.formData[itemNd.val]
                      ? detailData.formData[itemNd.val].slice(0, 10)
                      : '&nbsp;'
                  }}
                </span>
                <span v-else>
                  {{ detailData.formData[itemNd.val] || '&nbsp;' }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- tableData -->
        <div class="table-main">
          <PrintTable :data="detailData.list" />
        </div>
        <div class="table-main">
          <PrintTableTwo />
        </div>
        <div class="table-main">
          <PrintTableThree />
        </div>

        <!-- formData3 -->
        <div class="form-main">
          <div class="form-list">
            <div class="f-s-12 f-bold m-b-10">销售业务员确认：</div>
          </div>
          <div class="form-list">
            <div class="f-s-12 f-bold m-b-10">销售总监确认：</div>
          </div>
        </div>
      </div>
    </div>
    <div class="print-right">
      <div class="print-do">
        <div>
          <el-button class="print-btn" v-print="printData" type="primary" size="small">
            打印
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrintTable: () => import('./print-table'),
    PrintTableTwo: () => import('./print-table-two'),
    PrintTableThree: () => import('./print-table-three')
  },
  data() {
    return {
      loaded: false,
      detailData: {},
      printData: {
        id: 'print-content',
        popTitle: '&nbsp;'
      },
      formData1: [
        [
          {
            key: '采购单号',
            val: 'cai_gou_code'
          },
          {
            key: '供应单位',
            val: 'supplier_company_name'
          }
        ],
        [
          {
            key: '采购日期',
            val: 'cai_gou_bill_date'
          },
          {
            key: '交货日期',
            val: 'cai_gou_jiao_huo_ri_qi'
          }
        ]
      ]
    }
  },
  computed: {
    purchaseCode() {
      return this.$route.query.code
    }
  },
  mounted() {
    this.getDetailData()
  },
  methods: {
    // 获取详情数据
    getDetailData() {
      this.loaded = false
      this.$api({
        method: 'get',
        url: '/admin/gcvip/caigou/detailCaiGouCode',
        params: {
          code: this.purchaseCode
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = {}
            let list = []
            data.formData = this.$util.deepCopy(res.data.formData)
            data.he_tong_list = this.$util.deepCopy(res.data.he_tong_list)

            data.formData.buyer_company_name = res.data.company.saler_company_name
            data.formData.buyer_address = res.data.company.saler_address
            data.formData.buyer_linkman = res.data.company.saler_name
            data.formData.buyer_bank_code = res.data.company.saler_bank_code
            data.formData.buyer_bank_name = res.data.company.saler_bank_name

            data.formData.saler_company_name = res.data.supplier.supplier_name
            data.formData.saler_address = res.data.supplier.address
            data.formData.saler_linkman = res.data.supplier.linkman
            data.formData.saler_bank_code = ''
            data.formData.saler_bank_name = ''

            res.data.data.forEach((itemSt) => {
              itemSt.forEach((itemNd) => {
                list.push(itemNd)
              })
            })
            data.list = this.$util.deepCopy(list)
            this.detailData = this.$util.deepCopy(data)
          }
        })
        .catch(() => {})
        .then(() => {
          this.loaded = true
        })
    }
  }
}
</script>

<style lang="less" scoped>
// print
.print-main {
  display: flex;
  background: #f5f7fa;
  .print-left {
    margin: 10px;
    padding: 20px;
    width: 712px;
    background: #fff;
    overflow-y: auto;
    .scroll-bar();
  }
  .print-right {
    margin: 10px 10px 10px 0;
    padding: 10px;
    width: 200px;
    background: #fff;
    .print-btn {
      width: 100%;
    }
    .print-do {
      margin-bottom: 20px;
      padding: 20px;
      text-align: center;
      font-size: 14px;
      background: #f8f8f8;
    }
  }
}

// content
.print-content {
  font-size: 12px;
  line-height: 1.5;
  font-family: 'Arial,Microsoft YaHei,SimHei,SimSun';
  overflow: hidden;
}

// title
.title-box {
  margin: 10px 0 30px 0;
  text-align: center;
}
.title-main {
  margin: 0;
  font-size: 24px;
}
.title-sub {
  position: relative;
  margin: 20px 0 0 0;
  font-size: 20px;
}

// form
.form-main {
  position: relative;
  display: flex;
  margin-top: 20px;
}
.form-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  & ~ .form-list {
    margin-left: 10px;
  }
  .form-item {
    flex: 1;
    display: flex;
    align-items: center;
    .form-key {
      border-bottom: 1px solid #fff;
    }
    .form-val {
      flex: 1;
      padding: 2px 0;
      border-bottom: 1px solid #000;
    }
  }
}

// table
.table-main {
  margin: 20px 0;
}
</style>
